export default __webpack_public_path__ + "static/media/store_baidu.9fce83fc.svg";